var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeakerFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1111 4.9234V2.7446C18.3396 3.70495 21.4998 7.47134 21.4998 11.997C21.4998 16.5227 18.3396 20.2951 14.1111 21.2554V19.0766C17.1632 18.1703 19.39 15.3463 19.39 12C19.39 8.65378 17.1602 5.82974 14.1111 4.9234ZM2.5 8.83391V15.1692H6.72256L12.0015 20.4452V3.55796L6.72256 8.83391H2.5ZM16.749 12.003C16.749 10.1393 15.6716 8.53069 14.1111 7.75341V16.2555C15.6746 15.4753 16.749 13.8637 16.749 12.003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerFilled);
export default __webpack_public_path__ + "static/media/SpeakerFilled.f46dd58e51219673d2eaf95c6c347754.svg";
export { ForwardRef as ReactComponent };